import React from 'react';
import styles from './DocListPermit.module.scss';
import Attachment from '../../../../../../components/NewAttachment/NewAttachment';
import useGetDocUrl from '../../hooks/useGetDocUrl';
import useDeleteDoc from '../../api/useDeleteDoc';

const DocListPermit = ({ data = [], permitId }) => {
  const { mutateAsync } = useDeleteDoc();

  const getAttachmentUrl = useGetDocUrl();

  return (
    <ul className={styles.root}>
      {data.map((attach) => (
        <li key={attach.id}>
          <Attachment
            className={styles.attachment}
            attachments={data}
            attachment={attach}
            getAttachmentUrl={getAttachmentUrl({
              permitId,
            })}
            onDeleteAttachment={(attach) =>
              mutateAsync({ permitId, attachmentId: attach.id })
            }
          />
        </li>
      ))}
    </ul>
  );
};

export default DocListPermit;
